var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78 5.78015C6.92069 5.92066 6.99983 6.1113 7 6.31015L7 6.69015C6.9977 6.88856 6.91888 7.07843 6.78 7.22015L1.64 12.3501C1.54612 12.4448 1.41832 12.498 1.285 12.498C1.15168 12.498 1.02388 12.4448 0.93 12.3501L0.22 11.6401C0.125936 11.548 0.0729285 11.4218 0.0729285 11.2901C0.0729285 11.1585 0.125936 11.0323 0.22 10.9401L4.67 6.50015L0.220001 2.06015C0.125344 1.96626 0.0721016 1.83847 0.0721016 1.70515C0.0721016 1.57183 0.125344 1.44403 0.220001 1.35015L0.930001 0.650147C1.02388 0.555491 1.15168 0.502248 1.285 0.502248C1.41832 0.502248 1.54612 0.555491 1.64 0.650147L6.78 5.78015Z",
    fill: "#1E2C4F",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.8af180383c65c4d31b830cd2ddb741c7.svg";
export { ForwardRef as ReactComponent };